import { useEffect } from "react";

const CANONICAL_ORIGIN = "https://chptr.org";

function setMeta(name, content, isProperty = false) {
  if (!content) return;
  const attr = isProperty ? "property" : "name";
  let tag = document.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let tag = document.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
}

/**
 * Per-page SEO hook. Call in each route component.
 * - title:       string, will be suffixed with " · Chapter" unless already contains 'Chapter'
 * - description: 120–160 chars ideal
 * - path:        path used to build the absolute canonical URL. Defaults to window.location.pathname.
 * - noindex:     if true, adds meta robots noindex,nofollow
 */
export function useSeo({ title, description, path, noindex = false, ogImage } = {}) {
  useEffect(() => {
    const fullTitle = title
      ? title.toLowerCase().includes("chapter")
        ? title
        : `${title} · Chapter`
      : "Chapter — A story told by everyone";

    document.title = fullTitle;
    if (description) setMeta("description", description);

    const canonicalPath = path || (typeof window !== "undefined" ? window.location.pathname : "/");
    const canonicalHref = `${CANONICAL_ORIGIN}${canonicalPath}`;
    setLink("canonical", canonicalHref);

    setMeta("og:title", fullTitle, true);
    if (description) setMeta("og:description", description, true);
    setMeta("og:type", "website", true);
    setMeta("og:url", canonicalHref, true);
    setMeta("og:site_name", "Chapter", true);
    if (ogImage) setMeta("og:image", ogImage, true);

    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    if (description) setMeta("twitter:description", description);
    if (ogImage) setMeta("twitter:image", ogImage);

    setMeta("robots", noindex ? "noindex,nofollow" : "index,follow");
  }, [title, description, path, noindex, ogImage]);
}
